var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.node.children),function(child,index){return _c('docs-node',{key:index,attrs:{"node":child}})}))}
var staticRenderFns = []

export { render, staticRenderFns }